import axios from 'axios'
import { config, url } from '../../index'
import Sound from '@/classes/Sound'

const state = () => ({
  active: false,
  counter: +localStorage.getItem('counter') || null,
  notifications: [],
  popupNotifications: [],
  eventModal: {
    active: false,
    activity: null
  }
})

const getters = {
  getWidgetNotifications: state => state.notifications,
  getWidgetEventModal: state => state.eventModal,
  getPopupNotifications: state => state.popupNotifications,
  getNotificationWidgetActive: state => state.active,
  getNewNotificationCounter: state => state.counter
}

const mutations = {
  // уведомления
  GET_WIDGET_NOTIFICATIONS: (state, notifications) => {
    notifications = notifications.filter(notification => {
      let allowedNotification = false
      if (notification.itemable) {
        const reminder = notification.itemable.activity_reminds
        if (reminder && reminder.length) {
          reminder.forEach(reminderItem => {
            if (reminderItem.remind_at) {
              if (Date.parse(reminderItem.remind_at) < Date.now()) {
                allowedNotification = true
              }
            }
          })
        } else {
          allowedNotification = true
        }
      } else {
        allowedNotification = true
      }

      return allowedNotification
    })
    state.notifications = notifications
  },
  GET_WIDGET_NEW_NOTIFICATIONS: (state, newNotifications) => {
    const currentNotifications = state.notifications
    // commented by mootz
    // console.log('new current', newNotifications.length, currentNotifications.length)
    // Фильтрую новые уведомления, удаляя те время которых не пришло
    newNotifications = newNotifications.filter(notification => {
      let allowedNotification = false
      if (notification.itemable) {
        const reminder = notification.itemable.activity_reminds
        if (reminder && reminder.length) {
          reminder.forEach(reminderItem => {
            if (reminderItem.remind_at) {
              if (Date.parse(reminderItem.remind_at) < Date.now()) {
                allowedNotification = true
              }
            }
          })
        } else {
          allowedNotification = true
        }
      } else {
        allowedNotification = true
      }

      return allowedNotification
    })

    const difference = newNotifications.length - currentNotifications.length

    if (difference > 0) {
      state.counter += difference
      localStorage.setItem('counter', state.counter)
      const newArray = newNotifications.slice(0, difference)
      state.notifications = newNotifications
      state.popupNotifications = [...newArray, ...state.popupNotifications]

      Sound.notification.play()

      // для того чтобы не засорять экран оставляем только три последних увдомления
      if (state.popupNotifications.length > 3) {
        state.popupNotifications = [...state.popupNotifications].slice(0, 3)
      }
    } else {
      // можно туту обновлять список уведовмлений чтобы убрать удаленные
    }
  },
  TOGGLE_ASIDE_NOTIFICATION_WIDGET: (state) => {
    state.active = !state.active
    state.counter = null
    localStorage.removeItem('counter')
  },
  CLOSE_ASIDE_NOTIFICATION_WIDGET: (state) => {
    state.active = false
  },
  REMOVE_NOTIFICATION_WIDGET_NOTIFICATION: (state, notificationId) => {
    state.notifications = [...state.notifications].filter((item) => {
      return item.id !== notificationId
    })
  },
  CLOSE_POPUP_NOTIFICATION: (state, notificationId) => {
    state.popupNotifications = [...state.popupNotifications].filter((item) => {
      return item.id !== notificationId
    })
  },
  '[notification] SHOW_DETAIL_EVENT_MODAL': (state, item) => {
    state.eventModal.active = true
    state.eventModal.activity = {
      ...item,
      users: item.users ? item.users : [],
      departments: item.departments ? item.departments : [],
      groups: item.groups ? item.groups : []
    }
  },
  '[notification] CLOSE_DETAIL_EVENT_MODAL': (state, item) => {
    state.eventModal.active = false
    state.eventModal.activity = null
  }
}

const actions = {
  getAppNotifications ({ commit, rootState }) {
    axios.get(`${url}/event-items?search[type]=EventMessage,TaskProcess,Activity,ApproveProcess,Ppr&expand=itemable&sort=-id`, config).then(response => {
      const notOwnerNote = response.data.data
      commit('GET_WIDGET_NOTIFICATIONS', notOwnerNote)
      // после получения уведомлений запускает интервал получения новых
      // this.dispatch('getNewAppNotifications')
    }).catch(error => {
      console.log('Ошибка получения уведомлений:', error)
    })
  },

  removeNotificationWidgetNotification ({ commit }, notificationId) {
    axios.delete(`${url}/event-items/${notificationId}`, config).then(response => {
      commit('REMOVE_NOTIFICATION_WIDGET_NOTIFICATION', notificationId)
    }).catch(error => {
      console.log('ошибка удаления уведомления с сервера', error)
    })
  },

  closeNotificationWidget ({ commit }) {
    commit('CLOSE_ASIDE_NOTIFICATION_WIDGET')
  },
  closePopupNotification ({ commit }, notificationId) {
    commit('CLOSE_POPUP_NOTIFICATION', notificationId)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
